<script>
export default {

};
</script>

<template lang='pug'>
.w-1-4
  .w-2.flex.flex-wrap.h-2.cursor-pointer.items-center(
    tabindex='0',
    @click='$emit("open-menu")',
    @keyup.enter='$emit("open-menu")',
  )
    .w-full.h-px.border.border-brand.bg-brand
    .w-full.h-px.border.border-brand.bg-brand
    .w-full.h-px.border.border-brand.bg-brand
</template>

<style>
@import '~import/index';

</style>